import React from "react";
import "../scss/components/_footer.scss";
import { useTheme } from "../context/ThemeContext";
import { getTheme } from "../config/themes";
import { BRAND_NAME, CONTACT_EMAIL } from "../config/domain";

const CURRENT_YEAR = new Date().getFullYear();

function Footer() {
  const { theme } = useTheme();
  const activeLogo = getTheme(theme).logo;
  const [phone, setPhone] = React.useState(window._bvS?.phone || '');
  React.useEffect(() => {
    const onUpdate = () => setPhone(window._bvS?.phone || '');
    window.addEventListener('bv_settings_updated', onUpdate);
    if (window._bvS?.phone) setPhone(window._bvS.phone);
    return () => window.removeEventListener('bv_settings_updated', onUpdate);
  }, []);
  return (
    <footer className="site-footer">

      {/* wave divider */}
      <div className="site-footer__wave">
        <svg viewBox="0 0 1440 60" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0,30 C240,60 480,0 720,30 C960,60 1200,0 1440,30 L1440,60 L0,60 Z" fill="var(--bv-footer-bg, #2a1200)"/>
        </svg>
      </div>

      <div className="site-footer__inner">

        {/* logo + brand */}
        <div className="site-footer__brand">
          <img src={activeLogo.replace(/\.webp$/, '-sm.webp')} alt={window._bvS?.brandName || BRAND_NAME} className="site-footer__logo" loading="lazy" style={{width:"56px",height:"56px",objectFit:"contain"}}/>
          <div>
            <p className="site-footer__brand-name">{(window._bvS?.brandName || BRAND_NAME).toUpperCase()}</p>
            <p className="site-footer__brand-tagline">{window._bvS?.brandTagline || "Fresh Produce · Toronto"}</p>
          </div>
        </div>

        {/* divider */}
        <div className="site-footer__divider" />

        {/* contact */}
        <div className="site-footer__contact">
          <p className="site-footer__contact-title">CONTACT US</p>

          <a href={`tel:${phone}`} className="site-footer__contact-row">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 2.18h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
            </svg>
            <span>{phone ? phone.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3') : '...'}</span>
            <span className="site-footer__contact-tags">
              <span>Call</span><span>Text</span><span>WhatsApp</span>
            </span>
          </a>

          <a href={`mailto:${window._bvS?.email || CONTACT_EMAIL}`} className="site-footer__contact-row">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
              <polyline points="22,6 12,13 2,6"/>
            </svg>
            <span>{window._bvS?.email || CONTACT_EMAIL}</span>
          </a>
        </div>

        {/* divider */}
        <div className="site-footer__divider" />

        {/* terms of service */}
        <div className="site-footer__terms">
          <p className="site-footer__contact-title">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" width="13" height="13" style={{marginRight:'5px',verticalAlign:'middle',opacity:0.6}}><path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2"/><rect x="9" y="3" width="6" height="4" rx="1"/></svg>
            TERMS OF SERVICE
          </p>
          <div className="site-footer__terms-grid">
            <div className="site-footer__terms-item">
              <span className="site-footer__terms-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" width="18" height="18"><rect x="1" y="3" width="15" height="13" rx="2"/><path d="M16 8h4l3 5v3h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>
              </span>
              <div>
                <p className="site-footer__terms-label">DELIVERY TIME</p>
                <p className="site-footer__terms-val">1 business day</p>
              </div>
            </div>
            <div className="site-footer__terms-item">
              <span className="site-footer__terms-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" width="18" height="18"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>
              </span>
              <div>
                <p className="site-footer__terms-label">DELIVERY AREAS</p>
                <p className="site-footer__terms-val">{(window._bvS?.location || "Toronto,Brampton,Vaughan,Oakville,Mississauga").split(",").join(" · ")}</p>
              </div>
            </div>
            <div className="site-footer__terms-item">
              <span className="site-footer__terms-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" width="18" height="18"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/></svg>
              </span>
              <div>
                <p className="site-footer__terms-label">DELIVERY FEE</p>
                <p className="site-footer__terms-val">${window._bvS?.deliveryPrice || "9.99"} minimum delivery fee on all orders</p>
              </div>
            </div>
            <div className="site-footer__terms-item">
              <span className="site-footer__terms-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" width="18" height="18"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
              </span>
              <div>
                <p className="site-footer__terms-label">DROP-OFF POLICY</p>
                <p className="site-footer__terms-val">{window._bvS?.dropoffPolicy || "House: bell · Apt: concierge"}</p>
              </div>
            </div>
          </div>
        </div>

        {/* divider */}
        <div className="site-footer__divider" />
        <div className="site-footer__thanks">
          <p className="site-footer__contact-title">
            <svg viewBox="0 0 24 24" fill="currentColor" stroke="none" width="13" height="13" style={{marginRight:'5px',verticalAlign:'middle',opacity:0.7}}><path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/></svg>
            MADE WITH LOVE
          </p>
          <a
            href={window._bvS?.devInstagram || "https://www.instagram.com/fanbox.x"}
            target="_blank"
            rel="noopener noreferrer"
            className="site-footer__social"
          >
            {/* instagram icon */}
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <rect x="2" y="2" width="20" height="20" rx="5"/>
              <circle cx="12" cy="12" r="5"/>
              <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/>
            </svg>
            <span>{(window._bvS?.devInstagram || "").replace("https://www.instagram.com/","") || "fanbox.x"}</span>
          </a>
        </div>

        {/* divider */}
        <div className="site-footer__divider" />

        {/* copyright */}
        <p className="site-footer__copy">
          © 2024–{CURRENT_YEAR} <strong>{window._bvS?.brandName || BRAND_NAME}</strong>. All rights reserved.
        </p>

      </div>
    </footer>
  );
}

export default Footer;
